import { collection, type Reference, type Timestamp } from "@doitintl/models-types";

import { type CustomerModel } from "./Customer";

@collection("variables")
export class VariableValue {
  createdAt!: Timestamp;

  customer!: Reference<CustomerModel>;

  id!: string;

  name!: string;

  owner!: string;

  scope!: "global";

  type!: "string" | "number" | "boolean";

  updatedAt!: Timestamp;

  value!: string | number | boolean;
}

@collection("globalVariables")
export class GlobalVariableModel {
  docs?: Record<string, VariableValue>;
}

export type Variables = {
  globalVariables: VariableValue[];
  localVariables: VariableValue[];
};
